import React, { createContext, useContext, useEffect, useReducer, useRef, useState } from "react"
import { notification } from "antd"
import { useHistory } from "react-router-dom"
import { Auth } from "@aws-amplify/auth"
import API from "@aws-amplify/api"

import { listSiteProfile, getSiteProfile } from "../backend/graphql/queries"
import { listFixedList } from "../backend/graphql/custom_queries"
import { onUpdateClientProfile } from "../backend/graphql/subscriptions"
import { DataContext } from "../contexts/DataContext"
import { checkLoginUser } from '../utils/checkLocalStorage'

export const AppContext = createContext()

const initialState = {
    validClientLogin: checkLoginUser(),
    cognitoUserClient: {},
    profileClient: {},
    broken: false,
    backButton: false,
    backURL: "",
    pageTitle: "",
    pageSubtitle: "",
    fixedListLoaded: false,
    citizenshipList: [],
    nationalityList: [],
    incidentTypeList: [],
    raceList: [],
    religionList: [],
    plrdGradeList: [],
    designationList: [],
    emStatusList: [],
    emTypeList: [],
    purposeOfVisitList: [],
    siteList: [], // only for agency portal
    clientList: [], // only for agency portal
    permissionList: []
}

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_BROKEN":
            return {
                ...state,
                broken: action.payload,
            }
        case "SET_BACKBUTTON":
            return {
                ...state,
                backButton: action.payload,
            }
        case "SET_BACKURL":
            return {
                ...state,
                backURL: action.payload,
            }
        case "SET_PAGETITLE":
            return {
                ...state,
                pageTitle: action.payload,
            }
        case "SET_PAGESUBTITLE":
            return {
                ...state,
                pageSubtitle: action.payload,
            }
        case "SET_FIXEDLIST":
            return {
                ...state,
                ...action.payload,
            }
        case "SET_VALIDCLIENTLOGIN":
            return {
                ...state,
                validClientLogin: action.payload,
            }
        case "SET_COGNITOUSERCLIENT":
            return {
                ...state,
                cognitoUserClient: action.payload,
            }
        case "SET_PROFILEAGENCY":
            return {
                ...state,
                profileClient: action.payload,
            }
        default:
    }
}

const AppContextProvider = (props) => {
    const { dataState } = useContext(DataContext)
    const [appState, dispatch] = useReducer(reducer, initialState)
    const history = useHistory()
    // let subscriptionOnUpdateClientProfile

    // const getCitizenshipList = () => {
    //     return dataState.citizenshipList
    // }

    // const getNationalityList = () => {
    //     return dataState.nationalityList
    // }

    // const getIncidentTypeList = () => {
    //     return dataState.incidentTypeList
    // }

    // const getRaceList = () => {
    //     return dataState.raceList
    // }

    // const getReligionList = () => {
    //     return dataState.religionList
    // }

    // const getplrdGradeList = () => {
    //     return dataState.plrdGradeList
    // }

    const getDesignationList = () => {
        return dataState.designationList
    }

    const getEmStatusList = () => {
        return dataState.emStatusList
    }

    const getEmTypeList = () => {
        return dataState.emTypeList
    }

    const getPurposeOfVisitList = () => {
        return dataState.purposeOfVisitList
    }

    // const getSiteList = () => {
    //     return dataState.siteList
    // }

    // const getClientList = () => {
    //     return dataState.clientList
    // }

    const getPermissionList = () => {
        return dataState.permissionList
    }

    const getFixedList = async () => {
        // console.log("getFixedList");
        try {
            const result = await API.graphql({
                query: listFixedList,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                // authMode: "AWS_IAM",
                // query: listNationality,
            })
            // console.log("fixed list", result);

            dispatch({
                type: "SET_FIXEDLIST", payload: {
                    citizenshipList: result.data.listCitizenship.result,
                    nationalityList: result.data.listNationality.result,
                    incidentTypeList: result.data.listIncidentType.result,
                    raceList: result.data.listRace.result,
                    religionList: result.data.listReligion.result,
                    plrdGradeList: result.data.listPLRDGrade.result,
                    designationList: getDesignationList(), // no table, additional ADMIN option
                    emStatusList: getEmStatusList(), // no table
                    emTypeList: getEmTypeList(), // no table
                    purposeOfVisitList: getPurposeOfVisitList(), // no table
                    permissionList: getPermissionList(),
                    // fixedListLoaded: true,
                    // siteList: result.data.listSiteHistory.result,
                    // clientList: result.data.listClientProfile.result,
                }
            })
        }
        catch (error) {
            console.log("error: ", error);
            if (error.message === "No current user") {
                notification.error({
                    message: "Token has expired, please re-login."
                })
                await Auth.signOut()
                actionLogout()
            }
        }
        finally { }
    }

    const getSiteList = async () => {
        try {
            const listSiteListDetails = {
                filter: {
                    clientProfileID: { eq: appState.profileClient.clientProfileID }
                },
                pagination: {
                    agencyID: appState.profileClient.clientProfileID
                }
            }
            const result = await API.graphql({
                query: listSiteProfile,
                variables: listSiteListDetails,
                authMode: "AMAZON_COGNITO_USER_POOLS",
            })
            // console.log("listSiteProfile", result);

            dispatch({
                type: "SET_FIXEDLIST", payload: {
                    siteList: result.data.result.result === null ? [] : result.data.result.result,
                    fixedListLoaded: true,
                }
            })
        }
        catch (error) {
            console.log("error: ", error);
        }
        finally { }
    }

    // const getClientAndSiteList = async () => {
    //     try {
    //         const listSiteListDetails = {
    //             filter: {
    //                 securityAgencyID: { eq: appState.profileClient.securityAgencyID }
    //             },
    //             filter2: {
    //                 securityAgencyID: { eq: appState.profileClient.securityAgencyID }
    //             },
    //             pagination: {
    //                 agencyID: appState.profileClient.securityAgencyID
    //             }
    //         }
    //         const result = await API.graphql({
    //             query: listClientProfile,
    //             variables: listSiteListDetails,
    //             authMode: "AMAZON_COGNITO_USER_POOLS",
    //         })
    //         // console.log("listClientProfile", result);

    //         dispatch({
    //             type: "SET_FIXEDLIST", payload: {
    //                 // siteList: result.data.listSiteHistory.result === null ? [] : result.data.listSiteHistory.result,
    //                 // clientList: result.data.listClientProfile.result === null ? [] : result.data.listClientProfile.result,
    //                 siteList: result.data.result2.result === null ? [] : result.data.result2.result,
    //                 clientList: result.data.result.result === null ? [] : result.data.result.result,
    //                 fixedListLoaded: true,
    //             }
    //         })
    //     }
    //     catch (error) {
    //         console.log("error: ", error);
    //     }
    //     finally { }
    // }

    const getCognitoFromLocalStorage = async () => {
        const user = JSON.parse(localStorage.getItem("isap_cognitouser_client"))
        const cognitoGroups = user.signInUserSession.idToken.payload["cognito:groups"]
        // console.log("cognitoGroups", cognitoGroups);
        const profiles = JSON.parse(user.signInUserSession.idToken.payload.profiles)
        // console.log("profiles", profiles);

        let platformPermission = false

        // for (let i = 0; i < cognitoGroups.length; i++) {
        //     if (cognitoGroups[i] === "AgencyMasterAdmin" || cognitoGroups[i] === "AgencyAdmin") {
        //         if (profiles[0].cognitoGroup === "AgencyMasterAdmin" || profiles[0].cognitoGroup === "AgencyAdmin") {
        //             platformPermission = true
        //             break
        //         }
        //     }
        // }

        if (Object.keys(profiles[0]).length !== 0 && profiles[0].clientProfileID !== undefined && profiles[0].clientProfileID !== null) {
            platformPermission = true
        }

        if (platformPermission) {
            localStorage.setItem("isap_cognitouser_client", JSON.stringify(user))
            dispatch({ type: "SET_VALIDCLIENTLOGIN", payload: true })
            dispatch({ type: "SET_COGNITOUSERCLIENT", payload: user })
            dispatch({ type: "SET_PROFILEAGENCY", payload: profiles[0] })
        }
        else {
            try {
                await Auth.signOut();
            } catch (error) {
                console.log('error signing out: ', error);
            }
            notification.error({
                message: "Not a registered agency admin"
            })
        }
    }

    // const subscriptionOnUpdateClientProfileSetup = () => {
    //     try {
    //         subscriptionOnUpdateClientProfile = API.graphql({
    //             query: onUpdateClientProfile,
    //             authMode: "AMAZON_COGNITO_USER_POOLS",
    //             variables: { securityAgencyID: appState.profileClient.securityAgencyID }
    //         }).subscribe({
    //             next: async ({ provider, value }) => {
    //                 console.log(provider);
    //                 console.log(value);
    //             }
    //         })
    //     }
    //     catch (error) {
    //         console.log("error", error);
    //     }
    // }

    // useEffect(() => {
    //     console.log("appState", appState);
    // }, [appState])

    useEffect(() => {
        // getFixedList()
        // console.log("localStorage isap_cognitouser_client", localStorage.getItem("isap_cognitouser_client") !== undefined ? JSON.parse(localStorage.getItem("isap_cognitouser_client")) : "No data" );
        if (localStorage.getItem("isap_cognitouser_client") !== null) {
            getCognitoFromLocalStorage()
        }

        return () => {
            // if (subscriptionOnUpdateClientProfile !== undefined) {
            //     subscriptionOnUpdateClientProfile.unsubscribe()
            // }
        }
    }, [])

    useEffect(() => {
        if (Object.keys(appState.cognitoUserClient).length !== 0 && appState.fixedListLoaded === false) {
            getFixedList()
        }
    }, [appState.cognitoUserClient])

    // useEffect(() => {
    //     console.log("appState", appState);
    //     if (appState.profileClient.securityAgencyID !== undefined && appState.profileClient.securityAgencyID !== null) {
    //         subscriptionOnUpdateClientProfileSetup()
    //     }
    // }, [appState.profileClient])

    useEffect(() => {
        // if (appState.fixedListLoaded === true) {
        if (appState.fixedListLoaded === false && appState.nationalityList.length !== 0) {
            // get site under this client profile
            getSiteList()
            // getClientAndSiteList()
        }
        // }, [appState.fixedListLoaded])
    }, [appState.nationalityList])

    // Actions
    const actionLogin = (user) => {
        const profiles = JSON.parse(user.signInUserSession.idToken.payload.profiles)

        localStorage.setItem("isap_cognitouser_client", JSON.stringify(user))
        dispatch({ type: "SET_VALIDCLIENTLOGIN", payload: true })
        dispatch({ type: "SET_COGNITOUSERCLIENT", payload: user })
        dispatch({ type: "SET_PROFILEAGENCY", payload: profiles[0] })
    }

    const actionLogout = () => {
        dispatch({ type: "SET_VALIDCLIENTLOGIN", payload: false })
        dispatch({ type: "SET_COGNITOUSERCLIENT", payload: {} })
        dispatch({ type: "SET_PROFILEAGENCY", payload: {} })
        localStorage.removeItem("isap_cognitouser_client")
    }

    const actionSetBroken = (payload) => {
        dispatch({ type: "SET_BROKEN", payload: payload })
    }

    const actionSetPageTitle = (title, boolBackBtn, backURL) => {
        dispatch({ type: "SET_PAGETITLE", payload: title })
        if (boolBackBtn !== undefined)
            dispatch({ type: "SET_BACKBUTTON", payload: boolBackBtn })
        if (backURL !== undefined)
            dispatch({ type: "SET_BACKURL", payload: backURL })
    }

    return (
        <AppContext.Provider value={{ appState, actionLogin, actionLogout, actionSetBroken, actionSetPageTitle }}>
            {props.children}
        </AppContext.Provider>
    )
}

export default AppContextProvider